'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var pinInput = require('./pin-input-15ae64b6.js');

var getMapper = function (n) { return Array.from(Array(n), function (_, i) { return i; }); };
var PinCode = function (_a) {
    var length = _a.length, placeholder = _a.placeholder, onComplete = _a.onComplete, onInput = _a.onInput, restProps = tslib_es6.__rest(_a, ["length", "placeholder", "onComplete", "onInput"]);
    var _b = tslib_es6.__read(pinInput.useDirection(), 3), direction = _b[0], setForward = _b[1], setBackward = _b[2];
    var _c = tslib_es6.__read(pinInput.usePincode({ length: length, setForward: setForward, setBackward: setBackward }), 3), pincodes = _c[0], onCodeArrival = _c[1], onCodeWithdrawal = _c[2];
    var isInitialMount = React.useRef(true);
    React.useEffect(function () {
        if (onInput && isInitialMount.current === true) {
            isInitialMount.current = false;
        }
        else if (onInput && isInitialMount.current === false) {
            onInput(pincodes);
        }
        if (pincodes.length === length) {
            onComplete(pincodes);
        }
    }, [pincodes]);
    return (React__default.createElement("div", tslib_es6.__assign({}, restProps), getMapper(length).map(function (i) {
        var _a;
        var isFirstInput = pincodes.length === 0 && i === 0;
        var prevInputFilledAndNextIsEmpty = Number.isInteger(pincodes[i - 1]) && !pincodes[i];
        var prevInputFilledAndCurrentIsEmpty = !!pincodes[i] && !Number.isInteger(pincodes[i + 1]);
        var isFocused = isFirstInput
            || (prevInputFilledAndNextIsEmpty && direction === 'forward')
            || (prevInputFilledAndCurrentIsEmpty && direction === 'backward');
        return (React__default.createElement(pinInput.PinInput, { key: i, index: i, value: (_a = pincodes[i]) !== null && _a !== void 0 ? _a : '', placeholder: placeholder || '#', onCodeEntered: onCodeArrival, onCodeRemoved: onCodeWithdrawal, isFocused: isFocused }));
    })));
};

exports.PinCode = PinCode;
